<template>
  <main v-if="post">
    <banner
      :title="post.title"
      :image="post.image.path_full"
    />
        
    <div class="container-fluid bg-white">
      <div class="container blogcontainer">
        <div class="row pt-3 pt-sm-5">
          <div class="col-12">
            <h5><em>Posted on <time>{{ post.created_at }}</time></em></h5>
          </div>
        </div>
        <div class="row">
          <div
            class="col-12"
            v-html="post.content"
          />
        </div>
        <div class="row">
          <div class="col-12">
            <hr>
            <div id="disqus_thread" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Posts from '../services/posts.js';

export default {
  data () {
    return {
      post: null
    }
  },
  watch: {
    '$route.param.post': function (s) {
      this.fetchPost();
    },
  },
  mounted () {
    this.fetchPost();
  },
  methods: {
    fetchPost () {    
      Posts.get(this.$route.params.post).then(res => {
        this.post = res.data;
        window.scrollTo(0,0);
      });
    },
  }
}
</script>